import React, { useEffect, useState } from 'react';
import { Button, Card, Box, Grid, Text, Flex } from '@radix-ui/themes'
import { useSelector } from 'react-redux';
import WithdrawalForm from '../components/forms/teacher/WithdrawalForm';
import { InfoCircledIcon } from '@radix-ui/react-icons';
import { LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer } from "recharts";
import api from '../api'

const Withdrawals = () => {
    const finance = useSelector((state) => state.finance);
    const [showForm, setShowForm] = useState(false);
    const [earnings, setEarnings] = useState([]);

    // useEffect(() => {
    //     // console.log('finance::', ${finance.account.id})
    //     api.get(`/earnings?account_id=${finance.account.id}`)
    //         .then(response => {
    //             setEarnings(response.data);
    //         })
    //         .catch(error => console.error("Error fetching earnings:", error));
    // }, []);

    useEffect(() => {
        api.get(`/earnings?account_id=${finance.account.id}`)
            .then(response => {
                const groupedEarnings = response.data.reduce((acc, entry) => {
                    // Extract only the date part (YYYY-MM-DD)
                    const date = entry.date.split(" ")[0];

                    // Convert amount to a number
                    const amount = parseFloat(entry.amount);

                    // Sum earnings for the same date
                    acc[date] = (acc[date] || 0) + amount;

                    return acc;
                }, {});

                // Convert the grouped object into an array
                const formattedData = Object.entries(groupedEarnings).map(([date, amount]) => ({
                    date,
                    amount
                }));

                setEarnings(formattedData);
            })
            .catch(error => console.error("Error fetching earnings:", error));
    }, []);



    return (
        <Box width="100%" height="100%" align="start">
            <Grid
                columns={{ initial: '1', sm: '2' }}
                rows="auto"
                gapX="4"
                gapY="2"
            >
                <div style={{
                    gridColumn: { initial: '1', sm: '1' }
                }}>

                    <div className="flex flex-col gap-4">

                        <Card style={{ gridColumn: 'span 6' }} className='p-6'>
                            <div className="flex flex-row justify-between items-center mb-4">
                                {/* Available Balance Label */}
                                <p className="text-lg">Available Balance</p>

                                {/* Balance Value */}
                                <p className="text-lg text-right">
                                    {finance.account.currency}{' '}
                                    <span className="text-2xl font-bold">{finance.availableBalance}</span>
                                </p>
                            </div>


                            <div className="flex flex-col gap-8">

                                {showForm && (
                                    <WithdrawalForm setShowForm={setShowForm} />
                                )}

                                <Button
                                    onClick={() => setShowForm((prevState) => !prevState)}

                                    color={showForm ? "crimson" : "green"}
                                >
                                    {showForm ? 'Cancel Request' : 'Make a New Request'}
                                </Button>

                            </div>
                        </Card>

                        <Card className="space-y-4 w-full">
                            {/* Header */}
                            <div className="container">
                                <p className="text-lg font-bold text-primary mb-2">Withdrawal History</p>
                                <p className="text-base">
                                    <InfoCircledIcon size={24} color="#ff9800" className="inline-block mr-2" />
                                    You can make up to 2 withdrawals a month
                                </p>
                            </div>

                            {finance.withdrawals.length === 0 && (
                                <p className="text-base text-gray-600">
                                    You have no withdrawal history
                                </p>
                            )}

                            {/* List of Withdrawal Requests */}
                            {finance.withdrawals.map((withdrawalRequest) => (
                                <div
                                    key={`w${withdrawalRequest.id}`}
                                    className="p-3 rounded shadow border-gray-200"
                                    style={{
                                        backgroundColor: 'var(--gray-1)',
                                    }}
                                >
                                    <div className='flex flex-row justify-between items-center'>
                                        <p className="text-xl">{withdrawalRequest.currency} {withdrawalRequest.amount}</p>
                                        <p className="text-sm text-gray-600">
                                            {new Date(withdrawalRequest.requested_at).toLocaleDateString()}
                                        </p>
                                    </div>
                                    <p
                                        className={`text-base font-bold text-right ${withdrawalRequest.status === 'approved'
                                            ? 'text-green-500'
                                            : withdrawalRequest.status === 'pending'
                                                ? 'text-yellow-500'
                                                : withdrawalRequest.status === 'processed'
                                                    ? 'text-blue-500'
                                                    : withdrawalRequest.status === 'reversed'
                                                        ? 'text-purple-500'
                                                        : withdrawalRequest.status === 'rejected'
                                                            ? 'text-red-500'
                                                            : ''
                                            }`}
                                    >
                                        {withdrawalRequest.status.charAt(0).toUpperCase() + withdrawalRequest.status.slice(1)}
                                    </p>


                                </div>
                            ))}
                        </Card>
                    </div>


                </div>


                <Card style={{
                    gridColumn: { initial: '1', sm: '2' }
                }}>
                    <Box style={{ height: '200px' }}>
                        <h2 className="text-lg font-bold mb-4">Your Earnings Over Time</h2>
                        {earnings.length ? (



                            <ResponsiveContainer width="100%" height="100%">
                                <LineChart
                                    width={500}
                                    height={300}
                                    margin={{
                                        top: 5,
                                        right: 30,
                                        left: 0,
                                        bottom: 5,
                                    }}
                                    data={earnings}>
                                    <XAxis dataKey="date" tickFormatter={(date) => new Date(date).toLocaleDateString()} />
                                    <YAxis />
                                    <Tooltip labelFormatter={(label) => new Date(label).toLocaleDateString()} />
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <Line type="monotone" dataKey="amount" stroke="#8884d8" strokeWidth={2} />
                                </LineChart>
                            </ResponsiveContainer>

                        ) : (
                            <Flex direction="column" align="center" gap="4">
                                <Text>No earning data available</Text>
                            </Flex>
                        )}
                    </Box>
                </Card>
            </Grid>
        </Box>
    );

    return (
        <div className="flex flex-col gap-4 p-6">

            <Card style={{ gridColumn: 'span 6' }} className='p-6'>
                <div className="flex flex-row justify-between items-center mb-4">
                    {/* Available Balance Label */}
                    <p className="text-lg">Available Balance</p>

                    {/* Balance Value */}
                    <p className="text-lg text-right">
                        {finance.account.currency}{' '}
                        <span className="text-2xl font-bold">{finance.availableBalance}</span>
                    </p>
                </div>


                <div className="flex flex-col gap-8">

                    {showForm && (
                        <WithdrawalForm setShowForm={setShowForm} />
                    )}

                    <Button
                        onClick={() => setShowForm((prevState) => !prevState)}

                        color={showForm ? "crimson" : "green"}
                    >
                        {showForm ? 'Cancel Request' : 'Make a New Request'}
                    </Button>

                </div>
            </Card>

            <Card className="space-y-4 w-full">
                {/* Header */}
                <div className="container">
                    <p className="text-lg font-bold text-primary mb-2">Withdrawal History</p>
                    <p className="text-base">
                        <InfoCircledIcon size={24} color="#ff9800" className="inline-block mr-2" />
                        You can make up to 2 withdrawals a month
                    </p>
                </div>

                {finance.withdrawals.length === 0 && (
                    <p className="text-base text-gray-600">
                        You have no withdrawal history
                    </p>
                )}

                {/* List of Withdrawal Requests */}
                {finance.withdrawals.map((withdrawalRequest) => (
                    <div
                        key={`w${withdrawalRequest.id}`}
                        className="p-3 rounded shadow border-gray-200"
                        style={{
                            backgroundColor: 'var(--gray-1)',
                        }}
                    >
                        <div className='flex flex-row justify-between items-center'>
                            <p className="text-xl">{withdrawalRequest.currency} {withdrawalRequest.amount}</p>
                            <p className="text-sm text-gray-600">
                                {new Date(withdrawalRequest.requested_at).toLocaleDateString()}
                            </p>
                        </div>
                        <p
                            className={`text-base font-bold text-right ${withdrawalRequest.status === 'approved'
                                ? 'text-green-500'
                                : withdrawalRequest.status === 'pending'
                                    ? 'text-yellow-500'
                                    : withdrawalRequest.status === 'processed'
                                        ? 'text-blue-500'
                                        : withdrawalRequest.status === 'reversed'
                                            ? 'text-purple-500'
                                            : withdrawalRequest.status === 'rejected'
                                                ? 'text-red-500'
                                                : ''
                                }`}
                        >
                            {withdrawalRequest.status.charAt(0).toUpperCase() + withdrawalRequest.status.slice(1)}
                        </p>


                    </div>
                ))}
            </Card>
        </div>
    );
};

export default Withdrawals;
